export const TENANT_ADMIN_GATE_TOKEN_KEY = 'tenantAdminGateToken';
export const TENANT_ADMIN_GATE_EXPIRES_KEY = 'tenantAdminGateExpiresAt';
export const TENANT_ADMIN_GATE_HEADER = 'X-Tenant-Admin-Gate';
export const TENANT_ADMIN_GATE_EXPIRED_EVENT = 'tenant-admin-gate-expired';

const TENANT_ADMIN_API_PREFIX = '/api/admin/tenants';
const MASTER_USER_ADMIN_API_PREFIX = '/api/admin/master-users';

export function isTenantAdminApiUrl(url: string | undefined): boolean {
  if (!url) return false;
  const normalized = url.toLowerCase().split('?')[0];
  return (
    normalized.includes(TENANT_ADMIN_API_PREFIX)
    || normalized.includes(MASTER_USER_ADMIN_API_PREFIX)
  );
}

/** Rutas que no requieren el header de gate. */
export function tenantAdminUrlNeedsGateHeader(url: string | undefined): boolean {
  if (!url || !isTenantAdminApiUrl(url)) return false;
  const normalized = url.toLowerCase().split('?')[0];
  return !normalized.endsWith('/verify-access') && !normalized.endsWith('/access-status');
}

export function getGateToken(): string | null {
  if (typeof window === 'undefined') return null;
  const token = sessionStorage.getItem(TENANT_ADMIN_GATE_TOKEN_KEY);
  if (!token) return null;
  if (!isGateUnlocked()) {
    clearTenantAdminGate();
    return null;
  }
  return token;
}

export function setTenantAdminGate(token: string, expiresAt: string): void {
  if (typeof window === 'undefined') return;
  sessionStorage.setItem(TENANT_ADMIN_GATE_TOKEN_KEY, token);
  sessionStorage.setItem(TENANT_ADMIN_GATE_EXPIRES_KEY, expiresAt);
}

export function clearTenantAdminGate(): void {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(TENANT_ADMIN_GATE_TOKEN_KEY);
  sessionStorage.removeItem(TENANT_ADMIN_GATE_EXPIRES_KEY);
}

export function isGateUnlocked(): boolean {
  if (typeof window === 'undefined') return false;
  const token = sessionStorage.getItem(TENANT_ADMIN_GATE_TOKEN_KEY);
  const expiresAtRaw = sessionStorage.getItem(TENANT_ADMIN_GATE_EXPIRES_KEY);
  if (!token || !expiresAtRaw) return false;
  const expiresAt = Date.parse(expiresAtRaw);
  if (!Number.isFinite(expiresAt) || expiresAt <= Date.now()) {
    return false;
  }
  return true;
}

export function notifyTenantAdminGateExpired(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(TENANT_ADMIN_GATE_EXPIRED_EVENT));
}

export function isTenantAdminGateExpiredError(error: unknown): boolean {
  const err = error as { response?: { status?: number; data?: { code?: string; message?: string } } };
  if (err.response?.status !== 403) return false;
  const data = err.response.data;
  if (data?.code === 'tenant_admin_gate_expired') return true;
  const message = String(data?.message ?? '').toLowerCase();
  return (
    message.includes('expiró') ||
    message.includes('desbloquear la administración de tenants')
  );
}
